import { IPlaybookTemplateDetails } from './playbookTemplateDetails.interface';
import { PlaybookTemplateKey } from './playbookTemplateKey.enum';
import { Platform } from '../../api/common';

const baseTemplateLabelPath = 'playbooksMarketplace.playbookTemplates.';

export const PlaybookTemplatesDetailsModule: IPlaybookTemplateDetails[] = [
  {
    key: PlaybookTemplateKey.powerplatformSilentRemediation,
    platform: Platform.powerplatform,
    descriptionLabel: baseTemplateLabelPath + 'silentRemediationDescription',
    subTitleLabel: baseTemplateLabelPath + 'silentRemediationSubTitle',
    titleLabel: baseTemplateLabelPath + 'silentRemediationTitle',
  },
  {
    key: PlaybookTemplateKey.powerplatformAgentSetAuthentication,
    platform: Platform.powerplatform,
    descriptionLabel: baseTemplateLabelPath + 'agentSetAuthenticationDescription',
    subTitleLabel: baseTemplateLabelPath + 'agentSetAuthenticationSubTitle',
    titleLabel: baseTemplateLabelPath + 'agentSetAuthenticationTitle',
  },
  {
    key: PlaybookTemplateKey.powerplatformRemoveOrgWideAccess,
    platform: Platform.powerplatform,
    descriptionLabel: baseTemplateLabelPath + 'removeOrgWideAccessDescription',
    subTitleLabel: baseTemplateLabelPath + 'removeOrgWideAccessSubTitle',
    titleLabel: baseTemplateLabelPath + 'removeOrgWideAccessTitle',
  },
  {
    key: PlaybookTemplateKey.powerplatformRemoveOrgWideAccessApps,
    platform: Platform.powerplatform,
    descriptionLabel: baseTemplateLabelPath + 'removeOrgWideAccessAppsDescription',
    subTitleLabel: baseTemplateLabelPath + 'removeOrgWideAccessAppsSubTitle',
    titleLabel: baseTemplateLabelPath + 'removeOrgWideAccessAppsTitle',
  },
  {
    key: PlaybookTemplateKey.powerplatformRemoveOrgWideAccessConnections,
    platform: Platform.powerplatform,
    descriptionLabel: baseTemplateLabelPath + 'removeOrgWideAccessConnectionsDescription',
    subTitleLabel: baseTemplateLabelPath + 'removeOrgWideAccessConnectionsSubTitle',
    titleLabel: baseTemplateLabelPath + 'removeOrgWideAccessConnectionsTitle',
  },
];
